import React from "react";
import { SectionHeader, DataRow } from "./helperComponents";
import styles from "../Confirmation.module.css";
import { SectionProps } from "../types/confirmationTypes";
import {
  CONNECTION_TYPES_DATA,
  CONNECTION_TYPES_ENUM,
} from "../../../../../constants/autoImportConnectionTypes";
import {
  SCHEDULED_RUN_TIMES_DATA,
  SCHEDULED_RUN_TIMES_ENUM,
} from "../../../../../constants/scheduledRunTimesTypes";

export const GeneralInfoSection = ({ formData }: SectionProps) => {
  const {
    isActive,
    jobName,
    scheduledTime,
    scheduleType,
    client,
    forDtc,
    associatedInst,
    productType,
  } = formData;

  const scheduleTypeEntry = SCHEDULED_RUN_TIMES_DATA.find(
    (d) => d.value === scheduleType
  )?.text;

  return (
    <div className={styles.confirmationSection}>
      <SectionHeader title="General Information" />
      <div className={styles.confirmationSectionContent}>
        <DataRow
          label="Status"
          value={
            isActive ? (
              <span style={{ color: "green" }}>Active</span>
            ) : (
              <span style={{ color: "red" }}>Inactive</span>
            )
          }
        />
        <DataRow label="Job Name" value={jobName} />
        <DataRow label="Schedule Type" value={scheduleTypeEntry} />
        {scheduleType === SCHEDULED_RUN_TIMES_ENUM.DAILY && (
          <DataRow label="Schedule Time" value={scheduledTime} />
        )}
        <DataRow label="Client" value={client?.formattedName} />
        <DataRow label="For DTC" value={forDtc} />
        <DataRow label="Institution Number" value={associatedInst} />
        <DataRow label="Product Type" value={productType?.name} />
      </div>
    </div>
  );
};

export const SourceFileSection = ({ formData }: SectionProps) => {
  const {
    fileHasHeaderRow,
    expectedFileName,
    archiveAfterProcessing,
    archivePath,
    //fTP fields
    sftpEnabled,
    ftpServer,
    ftpPort,
    ftpUsername,
    ftpPassword,
    //blob fields
    blobStorageUsername,
    blobStoragePassword,
    blobStorageFolder,
    sourceFileType,
  } = formData;

  const typeEntry = CONNECTION_TYPES_DATA.find(
    (d) => d.value === sourceFileType
  );
  const connectionTypeLabel = typeEntry ? typeEntry.text : "-";

  const showFTP = sourceFileType === CONNECTION_TYPES_ENUM.FTP;
  const showBlob = sourceFileType === CONNECTION_TYPES_ENUM.BLOB;

  return (
    <div className={styles.confirmationSection}>
      <SectionHeader title="Source File" />
      <div className={styles.confirmationSectionContent}>
        {/* Common fields */}
        <DataRow
          label="File Has Header Row"
          value={
            fileHasHeaderRow ? (
              <span style={{ color: "green" }}>Yes</span>
            ) : (
              <span style={{ color: "red" }}>No</span>
            )
          }
        />
        <DataRow
          label="Expected File Name Matcher"
          value={expectedFileName || "-"}
        />
        <DataRow
          label="Archive After Processing"
          value={
            archiveAfterProcessing ? (
              <span style={{ color: "green" }}>Yes</span>
            ) : (
              <span style={{ color: "red" }}>No</span>
            )
          }
        />
        <DataRow label="Archive Path" value={archivePath || "-"} />

        <DataRow
          label="Connection Type"
          value={<strong>{connectionTypeLabel}</strong>}
        />

        {/* FTP settings */}
        {showFTP && (
          <>
            <DataRow
              label="Enable SFTP"
              value={
                sftpEnabled ? (
                  <span style={{ color: "green" }}>Yes</span>
                ) : (
                  <span style={{ color: "red" }}>No</span>
                )
              }
            />
            <DataRow label="FTP Server/Host" value={ftpServer || "-"} />
            <DataRow label="Port" value={ftpPort ?? "-"} />
            <DataRow label="FTP Username" value={ftpUsername || "-"} />
            <DataRow label="FTP Password" value={ftpPassword || "-"} />
          </>
        )}

        {/* Blob Storage settings */}
        {showBlob && (
          <>
            <DataRow
              label="Blob Storage Username"
              value={blobStorageUsername || "-"}
            />
            <DataRow
              label="Blob Storage Password"
              value={blobStoragePassword || "-"}
            />
            <DataRow
              label="Blob Storage Folder"
              value={blobStorageFolder || "-"}
            />
          </>
        )}
      </div>
    </div>
  );
};
